import { render } from "./QuestionThreeScreen.vue?vue&type=template&id=b81ac2bc&scoped=true&lang=html"
import script from "./QuestionThreeScreen.vue?vue&type=script&lang=js"
export * from "./QuestionThreeScreen.vue?vue&type=script&lang=js"

import "./QuestionThreeScreen.vue?vue&type=style&index=0&id=b81ac2bc&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_zendesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b81ac2bc"]])

export default __exports__